import React, { Component } from 'react';
import { getUserUrl } from '../../utilities/urlHelper';
import { trackAndExecute } from '../../utilities/analyticsUtilities';
import EVENT_TYPE from '../../utilities/EventType';

class EditLockModal extends Component {

    onClickEditAnyway = () => trackAndExecute(EVENT_TYPE.EDIT_LOCK_MODAL_EDIT_ANYWAY, {
        userId: window.userId,
        teamId: window.teamId,
    }, {}, this.props.closeModal);

    onClickEditLater = (e) => {
        e.preventDefault();
        return trackAndExecute(EVENT_TYPE.EDIT_LOCK_MODAL_EDIT_LATER, {
            userId: window.userId,
            teamId: window.teamId,
        }, {}, () => e.target.form.submit());
    };

    render() {
        const {
            authorEmail, authorId, authorImage, authorName, authorSlackId, authorTeamSlackId, discardUrl,
        } = this.props.existingDraft;
        const authorUrl = getUserUrl(authorId);

        return (
            <div className="react-modal open edit-lock-modal">
                <div className="modal-content">
                    <h2>Page draft in progress</h2>
                    <div className="mb2 flex">
                        <img className="avatar mr2 flex-none" src={authorImage} height="40" width="40" alt="{authorName} avatar" />
                        <p className="m0 flex-auto">
                            <a href={authorUrl} target="_blank" rel="noreferrer">{authorName}</a>
                            {' '}
currently has unpublished changes for this page.
                            <b>
                            Starting a new draft could cause changes to be lost.
                            </b>
                            {' '}
                            <br />
                            <br />
                        We suggest you
                            {' '}
                            <MessageButton
                                authorName={authorName}
                                authorEmail={authorEmail}
                                authorSlackId={authorSlackId}
                                authorTeamSlackId={authorTeamSlackId}
                            />
                            {' '}
before editing.
                        </p>
                    </div>

                    <form method="POST" action={discardUrl} acceptCharset="UTF-8">
                        <input name="_token" type="hidden" value={window.csrfToken} />
                        <input type="hidden" name="_method" value="delete" />
                        <div className="right-align mt3">
                            <span className="btn-secondary mr1 react-modal-close" onClick={this.onClickEditAnyway}>Edit anyway</span>
                            <input className="btn btn-primary mr1" type="submit" onClick={this.onClickEditLater} value="Nevermind, I'll edit later." />
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

class MessageButton extends Component {

    trackMessageButtonClick = (destination) => {
        window.analytics.track(EVENT_TYPE.MESSAGE_LOCK_MODAL, {
            userId: window.userId,
            teamId: window.teamId,
            destination,
        });
    };

    render() {
        const {
            authorName, authorEmail, authorSlackId, authorTeamSlackId,
        } = this.props;
        const draftTitle = window._tettraDraft ? window._tettraDraft.title : window.draftTitle;
        const currentUserHasSlack = window.hasSlack;

        if (currentUserHasSlack && authorSlackId && authorTeamSlackId) {
            const url = `slack://user?team=${authorTeamSlackId}&id=${authorSlackId}`;
            return (
                <a href={url} target="_blank" onClick={() => this.trackMessageButtonClick('slack')} rel="noreferrer">{`check with @${authorName}`}</a>
            );
        }
        const url = window.encodeURI(`mailto:${authorEmail}?subject=Are you still editing Tettra page ${draftTitle}?&body=Hi ${authorName}, I would like to edit this page, is that OK?`);
        return (
            <a href={url} target="_blank" onClick={() => this.trackMessageButtonClick('email')} rel="noreferrer">{`check with ${authorName}`}</a>
        );
    }
}

export default EditLockModal;
